(function() {
  function init() {
    const SELECTORS = [
      '.collection-list-wrapper .collection-list.grid',
      '#shopify-section-template--27751621460251__google_reviews .g-reviews__track'
    ];
    SELECTORS.forEach(sel => document.querySelectorAll(sel).forEach(attach));
  }
  function attach(track) {
    if (track.dataset.scrollArrowsInit) return;
    track.dataset.scrollArrowsInit = '1';
    const wrap = document.createElement('div');
    wrap.className = 'scroll-arrows';
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(track);
    const prev = makeBtn('prev', 'Previous');
    const next = makeBtn('next', 'Next');
    const nav = document.createElement('div');
    nav.className = 'scroll-arrows__nav';
    nav.appendChild(prev);
    nav.appendChild(next);
    wrap.appendChild(nav);
    const stepFor = () => {
      const first = track.querySelector(':scope > *');
      if (!first) return track.clientWidth * 0.9;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      return first.getBoundingClientRect().width + gap;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -stepFor(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: stepFor(), behavior: 'smooth' }));
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const x = track.scrollLeft;
      const overflows = max > 4;
      wrap.classList.toggle('scroll-arrows--has-overflow', overflows);
      prev.disabled = !overflows || x <= 1;
      next.disabled = !overflows || x >= max - 1;
    };
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function makeBtn(dir, label) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'scroll-arrows__btn scroll-arrows__btn--' + dir;
    btn.setAttribute('aria-label', label);
    btn.innerHTML = dir === 'prev'
      ? '<svg viewBox="0 0 10 18" width="10" height="18" aria-hidden="true"><path d="M9 1 1 9l8 8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg viewBox="0 0 10 18" width="10" height="18" aria-hidden="true"><path d="M1 1l8 8-8 8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return btn;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

